import portsApi from '../framework/ports/portsApi';

const ScrollFrontend = {
  saveScrollPosition: (): void => {
    portsApi.invoke('Scroll.saveScrollPosition');
  },
  scrollTop: (): void => {
    portsApi.invoke('Scroll.scrollTop');
  },
  restoreScrollPosition: (): void => {
    portsApi.invoke('Scroll.restoreScrollPosition');
  },
};

export default ScrollFrontend;
